<template>
  <div
    v-on-clickaway="away"
    class="grid-x"
  >
    <div class="small-3 cell text-right">
      <div class="label">
        Date Range
      </div>
    </div>
    <div class="small-9 cell text-left">
      <div class="date-picker-border">
        <div class="date-picker-fields-cont">
          <div class="date-picker-input-cont">
            <input
              ref="fromDay"
              v-model="fromDate.new.day"
              type="text"
              class="date-input"
              :class="{ validationFail: fromDate.new.dayVal }"
              value=""
              maxlength="2"
              @click="openDatePickerModal()"
              @keypress="isNumber()"
              @blur="isValidDay(fromDate.new.day, 'fromDate')"
            >/
            <input
              v-model="fromDate.new.month"
              type="text"
              class="date-input"
              :class="{ validationFail: fromDate.new.monthVal }"
              value=""
              maxlength="2"
              @click="openDatePickerModal()"
              @keypress="isNumber()"
              @blur="isValidMonth(fromDate.new.month, 'fromDate')"
            >/
            <input
              v-model="fromDate.new.year"
              type="text"
              class="date-input year"
              :class="{ validationFail: fromDate.new.yearVal }"
              value=""
              maxlength="4"
              @click="openDatePickerModal()"
              @keypress="isNumber()"
              @blur="isValidYear(fromDate.new.year, 'fromDate')"
            >
          </div>

          <div class="date-input-label">
            to
          </div>

          <div class="date-picker-input-cont">
            <input
              v-model="toDate.new.day"
              type="text"
              class="date-input"
              :class="{ validationFail: toDate.new.dayVal }"
              value=""
              maxlength="2"
              @click="openDatePickerModal()"
              @keypress="isNumber()"
              @blur="isValidDay(toDate.new.day, 'toDate')"
            >/
            <input
              v-model="toDate.new.month"
              type="text"
              class="date-input"
              :class="{ validationFail: toDate.new.monthVal }"
              value=""
              maxlength="2"
              @click="openDatePickerModal()"
              @keypress="isNumber()"
              @blur="isValidMonth(toDate.new.month, 'toDate')"
            >/
            <input
              v-model="toDate.new.year"
              type="text"
              class="date-input year"
              :class="{ validationFail: toDate.new.yearVal }"
              value=""
              maxlength="4"
              @click="openDatePickerModal()"
              @keypress="isNumber()"
              @blur="isValidYear(toDate.new.year, 'toDate')"
            >
          </div>
        </div>

        <div style="display: inline-block; margin-top: 23px; float: right; ">
          <rare-date-picker-arrow id="datepicker-trigger" />
        </div>

        <div
          v-if="datePickerModalState"
          class="date-widget-modal-cont"
        >
          <div class="datepicker-trigger">
            <AirbnbStyleDatepicker
              :from-date="fromDate.new.full"
              :to-date="toDate.new.full"
              :trigger-element-id="'datepicker-trigger'"
              :mode="'range'"
              :inline="true"
              :months-to-show="2"
              :start-open="true"
              :min-date="minDate"
              :end-date="endDate"
              :enable-apply-button="enableApplyButton"
              :show-shortcuts-menu-trigger="false"
              @date-one-selected="datePickerOneSelected"
              @date-two-selected="datePickerTwoSelected"
              @cancelled="datePickerResetToDefault"
              @apply="datePickerApply"
            >
              <rare-date-left-picker-arrow slot="previous-month-icon" />
              <rare-date-right-picker-arrow slot="next-month-icon" />
            </AirbnbStyleDatepicker>
            <div class="comparison-cont">
              <div class="grid-x">
                <div class="small-11 cell text-left">
                  <label class="comparison-check">
                    <input
                      v-model="comparisonCheckBox.new"
                      type="checkbox"
                      @change="updateComparisonMode"
                    >
                    Compare date range to the same time last year
                  </label>
                </div>
                <div class="small-1 cell text-right">
                  <!--<select class="comparison-years"
                          @change="comparisonYearsChange"
                          :disabled="!comparisonCheckBox.new"
                          v-model="comparisonYears" >
                    <option value="1" selected>Last year</option>
                    <option value="3">Last 3 years</option>
                  </select>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

import RareDatePickerArrow from '../icons/RareDatePickerArrow.vue';
import RareDateLeftPickerArrow from '../icons/RareDatePickerLeftArrow.vue';
import RareDateRightPickerArrow from '../icons/RareDatePickerRightArrow.vue';

export default {
  name: 'RareDatePicker',
  components: {
    'rare-date-picker-arrow': RareDatePickerArrow,
    'rare-date-left-picker-arrow': RareDateLeftPickerArrow,
    'rare-date-right-picker-arrow': RareDateRightPickerArrow,
  },
  directives: {
    onClickaway,
  },
  data() {
    return {
      toDate: {
        old: {
          full: '',
          day: '',
          month: '',
          year: '',
        },
        new: {
          full: '',
          day: '',
          month: '',
          year: '',
          dayVal: false,
          monthVal: false,
          yearVal: false,
        },
      },
      fromDate: {
        old: {
          full: '',
          day: '',
          month: '',
          year: '',
        },
        new: {
          full: '',
          day: '',
          month: '',
          year: '',
          dayVal: false,
          monthVal: false,
          yearVal: false,

        },
      },

      minDate: '',
      endDate: '',
      widgetModalOpen: false,
      comparisonCheckBox: {
        new: false,
        old: false,
      },
      comparisonYears: '1',
    };
  },
  computed: {
    datePickerModalState() {
      return this.$store.getters.datePickerModalState;
    },
    enableApplyButton() {
      return !(this.comparisonCheckBox.new === this.comparisonCheckBox.old
          && this.fromDate.new.full === this.fromDate.old.full
        && this.toDate.new.full === this.toDate.old.full);
    },
  },
  created() {
    document.addEventListener('keyup', this.watchForEsc);

    this.minDate = '2015-10-10';
    this.endDate = this.moment().format('YYYY-MM-DD');

    this.fromDate.new.full = this.$store.getters.fromDate;
    this.toDate.new.full = this.$store.getters.toDate;

    this.fromDate.new.day = this.moment(this.fromDate.new.full, 'YYYY-MM-DD').format('DD');
    this.fromDate.new.month = this.moment(this.fromDate.new.full, 'YYYY-MM-DD').format('MM');
    this.fromDate.new.year = this.moment(this.fromDate.new.full, 'YYYY-MM-DD').format('YYYY');

    this.toDate.new.day = this.moment(this.toDate.new.full, 'YYYY-MM-DD').format('DD');
    this.toDate.new.month = this.moment(this.toDate.new.full, 'YYYY-MM-DD').format('MM');
    this.toDate.new.year = this.moment(this.toDate.new.full, 'YYYY-MM-DD').format('YYYY');

    this.fromDate.old.full = this.fromDate.new.full;
    this.toDate.old.full = this.toDate.new.full;

    this.fromDate.old.day = this.fromDate.new.day;
    this.fromDate.old.month = this.fromDate.new.month;
    this.fromDate.old.year = this.fromDate.new.year;

    this.toDate.old.day = this.toDate.new.day;
    this.toDate.old.month = this.toDate.new.month;
    this.toDate.old.year = this.toDate.new.year;
  },

  mounted() {
  },
  methods: {
    datePickerOneSelected(val) {
      if (val !== '') {
        this.fromDate.new.full = val;
        this.fromDate.new.day = this.moment(val).format('DD');
        this.fromDate.new.month = this.moment(val).format('MM');
        this.fromDate.new.year = this.moment(val).format('YYYY');
      } else {
        // CODE REVIEW: relying on vagaries we don't understand to provide
        // functionality is fragile. we should understand and control this properly

        // For some reason this hook is called when the date picker becomes
        // visible. Only thing is val is empty.
        // Although strange, we can use this as am opportunity to save the
        // current value.
        this.fromDate.old.full = this.fromDate.new.full;
        this.fromDate.old.day = this.fromDate.new.day;
        this.fromDate.old.month = this.fromDate.new.month;
        this.fromDate.old.year = this.fromDate.new.year;
        this.comparisonCheckBox.old = this.comparisonCheckBox.new;
      }
    },
    datePickerTwoSelected(val) {
      if (val !== '') {
        this.toDate.new.full = val;
        this.toDate.new.day = this.moment(val).format('DD');
        this.toDate.new.month = this.moment(val).format('MM');
        this.toDate.new.year = this.moment(val).format('YYYY');
      } else {
        // For some reason this hook is called when the date picker becomes
        // visible. Only thing is val is empty.
        // Although strange, we can use this as am opportunity to save the
        // current value.
        this.toDate.old.full = this.toDate.new.full;
        this.toDate.old.day = this.toDate.new.day;
        this.toDate.old.month = this.toDate.new.month;
        this.toDate.old.year = this.toDate.new.year;
        this.comparisonCheckBox.old = this.comparisonCheckBox.new;
      }
    },
    datePickerApply() {
      if (this.moment(this.fromDate.new.full).isValid()
          && this.moment(this.toDate.new.full).isValid()) {
        if (this.comparisonCheckBox.new === true) {
          this.$store.commit('updateCurrentColors', 'multi', { root: true });
          this.$store.commit('updateComparisonMode', 'date');
        } else if (this.comparisonCheckBox.new === false) {
          this.$store.commit('updateCurrentColors', 'blueGrey', { root: true });
          this.$store.commit('updateComparisonMode', 'industry');
        }
        this.$store.commit('updateFromDate', this.fromDate.new.full);
        this.$store.commit('updateToDate', this.toDate.new.full);

        this.$store.commit('updateDatePickerModalState', false);

        this.updateComparisonMode();

        this.$emit('datePickerApplyClicked');
      } else {
        // eslint-disable-next-line
        alert('Please make sure both dates are entered or selected properly');
      }
    },
    openDatePickerModal() {
      this.$store.commit('updateDatePickerModalState', true);
    },
    datePickerResetToDefault() {
      const { defaultFromDate } = this.$store.getters;
      const { defaultToDate } = this.$store.getters;

      this.fromDate.new.full = defaultFromDate;
      this.fromDate.new.day = this.moment(defaultFromDate).format('DD');
      this.fromDate.new.month = this.moment(defaultFromDate).format('MM');
      this.fromDate.new.year = this.moment(defaultFromDate).format('YYYY');

      this.toDate.new.full = defaultToDate;
      this.toDate.new.day = this.moment(defaultToDate).format('DD');
      this.toDate.new.month = this.moment(defaultToDate).format('MM');
      this.toDate.new.year = this.moment(defaultToDate).format('YYYY');

      this.$store.commit('updateComparisonMode', 'industry');
      this.comparisonCheckBox.new = false;
      this.datePickerApply();
    },
    datePickerResetToPrevState() {
      this.fromDate.new.full = this.fromDate.old.full;
      this.fromDate.new.day = this.fromDate.old.day;
      this.fromDate.new.month = this.fromDate.old.month;
      this.fromDate.new.year = this.fromDate.old.year;

      this.toDate.new.full = this.toDate.old.full;
      this.toDate.new.day = this.toDate.old.day;
      this.toDate.new.month = this.toDate.old.month;
      this.toDate.new.year = this.toDate.old.year;

      this.comparisonCheckBox.new = this.comparisonCheckBox.old;
      this.updateComparisonMode();
    },
    updateComparisonMode() {
      if (this.comparisonCheckBox.new === true) {
        this.$store.commit('updateIndustrySelectStateDisabled', true);
      } else if (this.comparisonCheckBox.new === false) {
        this.$store.commit('updateIndustrySelectStateDisabled', false);
      }
    },
    comparisonYearsChange() {
      this.$store.commit('updateComparisonYears', this.comparisonYears);
    },
    // Validation functions...
    isNumber(evt) {
      // eslint-disable-next-line
      evt = (evt) ? evt : window.event;
      let returnVal = null;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
        returnVal = false;
      } else {
        returnVal = true;
      }
      return returnVal;
    },
    isValidDay(val, toFrom) {
      const febMaxDays = (this.moment([this[toFrom].new.month]).isLeapYear() ? 29 : 28);
      const daysInMonthArray = [31, febMaxDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      const daysIndex = parseInt(this[toFrom].new.month, 10) - 1;
      const maxDays = daysInMonthArray[daysIndex];
      const enteredDays = parseInt(val, 10);
      if ((enteredDays <= maxDays) === true) {
        this[toFrom].new.day = val;
        this[toFrom].new.dayVal = false;
        this[toFrom].new.full = `${this[toFrom].new.year}-${this[toFrom].new.month}-${this[toFrom].new.day}`;
        this.buildFullYear(toFrom);
      }
    },
    isValidMonth(val, toFrom) {
      if (val.length === 1) { this[toFrom].new.month = `0${val}`; }

      if ((parseInt(val, 10) <= 12 && parseInt(val, 10) >= 1) === true) {
        this[toFrom].new.monthVal = false;
        this[toFrom].new.month = val;
        this.buildFullYear(toFrom);
        // Re-validate the day field now, as the month has changed.
        if (!this[toFrom].new.monthVal) { this.isValidDay(this[toFrom].new.day, toFrom); }
      }
    },
    isValidYear(val, toFrom) {
      if ((parseInt(val, 10) <= this.moment().format('YYYY') && parseInt(val, 10) >= 2013) === true) {
        this[toFrom].new.yearVal = false;
        this[toFrom].new.year = val;
        this.buildFullYear(toFrom);
      }
    },
    buildFullYear(toFrom) {
      this[toFrom].new.full = `${this[toFrom].new.year}-${this[toFrom].new.month}-${this[toFrom].new.day}`;
      return true;
    },
    watchForEsc(key) {
      if (key.keyCode === 27) {
        this.datePickerReset();
        this.$store.commit('updateDatePickerModalState', false);
      }
    },
    away() {
      if (this.$store.getters.datePickerModalState === true) {
        this.datePickerResetToPrevState();
        this.$store.commit('updateDatePickerModalState', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .date-picker-border {
    width: 96%;
    height: 60px;
    border-radius: 30px;
    border: 1px solid $common-mid-grey;
    margin: -20px 0 10px 15px;
    position: relative;
  }

  .date-picker-fields-cont {
    float: left;
    margin: 14px 0 0 20px;
  }

  .date-picker-input-cont {
    display: inline-block;
    width: 125px;
    height: 30px;
    border-radius: 15px;
    border: 0;
    background-color: #eeeeee;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.71;
    letter-spacing: 2px;
    text-align: center;
    color: #4a5b68;
    padding: 4px 0 0 8px;
    -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  }

  .date-input-label {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.43;
    letter-spacing: 1px;
    color: #4a5b68;
    padding: 0;
    background-color: transparent;
    margin: 0 5px 0 5px;
  }

  .date-input {
    border: 0;
    background: transparent;
    display: inline-block;
    margin: 0 -5px 0 -7px;
    padding: 0;
    box-shadow: none;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.71;
    letter-spacing: 2px;
    text-align: left;
    color: #4a5b68;
    width: 23px;
    height: 20px;
  }

  .year {
    width: 46px !important;
  }

  .dates {
    display: none;
  }

  .date-widget-modal-cont {
    display: inline-block;
    width: 640px;
    height: 520px;
    border-radius: 25px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
    border: solid 1px #b4bfc8;
    background-color: #ffffff;
    position: absolute;
    top: 100%;
    right: 0%;
    z-index: 99;
    margin: 0 0 0 0;
  }

  .comparison-cont {
    padding: 14px 0 0 0;
    border-top: 1px solid #b4bfc8;
    border-bottom: 1px solid #b4bfc8;
    margin: -150px 40px 0 40px;
  }

  .comparison-check {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.43;
    letter-spacing: 1px;
    color: #4a5b68;
    padding-bottom: -2px;
  }

  .comparison-years {
    display: inline-block;
    width: 210px;
    height: 40px;
  }

  .validationFail {
    border-bottom: 2px solid #da0202;
  }
</style>

<style>
.asd__wrapper {
border: 0;
margin-left: 21px;
margin-top: 20px;
}

.asd__day-title {
  font-size: 14px;
}

.asd__month-name {
  margin-bottom: 40px;
}

.asd__action-buttons {
  margin-top: 75px;
}

/* This is the cancel button */
.asd__action-buttons button:first-child {
  float: left;
  left: 15px;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  color: #7d8b96;
  padding-bottom: 5px;
  border-bottom: 1px dashed #7d8b96;
  margin-top: 14px !important;
}

/* This is the apply button */
.asd__action-buttons button:nth-child(2) {
  float: right;
  right: 15px;
  display: inline-block;
  width: 110px;
  height: 40px;
  border-radius: 20px;
  background-color: #50e3c2;
  text-align: center;
  color: #ffffff !important;
}

.asd__action-buttons button:hover {
  text-decoration: none !important;
}

.asd__change-month-button {
  background-color: transparent !important;
}

.asd__change-month-button>button, .asd__change-month-button>button:hover {
  background-color: transparent !important;
  border: 0;
}

.asd__change-month-button>button>svg {
  height: 40px;
  width: 40px;
  fill: none;
}

.asd__day--enabled:hover {
  background-color: #b4bfc8;
}

.asd__change-month-button--next {
  padding-right: 0 !important;
}

.asd__day--today {
  background-color: #dddddd;
}

.pre-select-day {
  color: #ffffff !important;
  background-color: #7F8B95;
}

.pre-to-from-day {
  color: #ffffff !important;
  background-color: #4D5B67 !important;
}

button:focus {outline:0;}

</style>
